import * as React from "react";
import { forwardRef } from "react";
const SvgGaugeArrowRight = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 26, viewBox: "0 0 24 26", fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M20.5 13.866L22 13L20.5 12.134L5.5 3.47372L4 2.60769V4.33975V21.6603V23.3923L5.5 22.5263L20.5 13.866Z", fill: "white", stroke: "black", strokeWidth: 2 }));
const ForwardRef = forwardRef(SvgGaugeArrowRight);
export { ForwardRef as ReactComponent };
